<template>
<div id="clientes_certificaciones">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12">
        <base-material-card color="primary" icon="library_books" title="Mis Certificaciones" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <b>Simulación en descargos: </b>&nbsp;<v-chip small color="success" outlined @click="modal_fecha=true">{{fecha_simulacion != null ? fecha_simulacion : "Deshabilitado"}}</v-chip>
            <v-spacer></v-spacer>
            <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>

            <v-dialog v-model="modal" max-width="30%" style=" z-index: 400 !important;">
              <v-card>
                <v-card-title>
                  <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text" @click.native="modal = false">cancel</v-icon>&nbsp;
                    <span class="subheading">
                      <strong>{{ update ? "Actualizar" : "Nueva" }} Certificación</strong>
                    </span>
                  </v-card>

                </v-card-title>
                <v-form ref="form" lazy-validation>
                  <v-card-text>
                    <br>
                    <v-container fluid grid-list-md text-xs-center @keyup.enter="guardar()">
                      <v-row row wrap>
                        <v-col sm="12">
                          <v-autocomplete value="0" v-model="model.activo" :items="select_activo" item-text="text" item-value="value" label="Identificador de Caso CI" />
                        </v-col>
                        <v-col sm="12">
                          <v-autocomplete v-model="model.id_tipo_certificacion" :items="tipo_certificaciones" item-text="text" item-value="id" label="Rubro Certificación en la modalidad IVA & IEPS" :rules="[rules.required]" />
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="12">
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                              <v-text-field v-on="on" v-model="model.fecha_aprobacion" label="Fecha de Aprobación" color="secondary" prepend-icon="event" @blur="model.fecha_aprobacion = parseDate(model.fecha_aprobacion)" v-mask="'####-##-##'"
                                :rules="[rules.required]"></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_aprobacion" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false">
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                        <v-col class="d-flex" cols="12" sm="12">
                          <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                              <v-text-field v-on="on" v-model="model.fecha_termino" label="Fecha de Vigencia" color="secondary" prepend-icon="event" @blur="model.fecha_termino = parseDate(model.fecha_termino)" v-mask="'####-##-##'"
                                :rules="[rules.required]"></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_termino" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu2 = false">
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                        <v-col sm="12">
                          <v-text-field rows="1" label="Folio" auto-grow v-model="model.folio" :rules="[rules.required]"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-form>
                <v-card-actions>
                  <v-btn @click.native="modal = false">
                    <v-icon>cancel</v-icon> Cancelar
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="success" :loading="loading" @click.native="guardar()">
                    <v-icon>done</v-icon>
                    {{ update ? "Actualizar" : "Guardar" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-actions>

          <v-card-text>
            <div id="datagrid">

              <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                </template>

                <template slot="adjunto" slot-scope="props">
                  <div class="" style="text-align:center;">
                    <v-btn x-small fab dark color="blue" icon v-if="props.row.adjunto == '' || props.row.adjunto == null || props.row.adjunto == undefined" @click="abrir_modal_adjuntos(props.row.id)">
                      <v-icon>mdi-upload</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="blue" icon v-else @click="descargar_adjunto(props.row.adjunto)">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </div>
                </template>

                <template slot="actions" slot-scope="props">
                  <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                    <template v-slot:activator>
                      <v-btn :id="props.row.id" x-small fab dark color="primary">
                        <v-icon>reorder</v-icon>
                      </v-btn>
                    </template>

                    <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id)" title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="pink" @click.native="deleteRegistro(props.row.id)" title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>
              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
  <v-dialog v-model="modal_fecha" max-width="20%" style=" z-index: 400 !important;">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">

          <v-icon class="white--text" @click.native="modal_fecha = false">cancel</v-icon>&nbsp;
          <span class="subheading">
            <strong>Configurar Simulación en Descargos</strong>
          </span>
        </v-card>

      </v-card-title>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <br>
          <h5>Simulación:  <v-switch v-model="habilitar" color="primary" :label="habilitar==true?'Activada':'Desactivada'" ></v-switch></h5>
         
          <v-container fluid grid-list-md text-xs-center @keyup.enter="guardar_fecha()">
            <v-row row wrap>
              <v-col class="d-flex" cols="12" sm="12">
                
                <v-menu v-if="habilitar" offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-on="on" v-model="fecha_simulacion" label="Fecha" color="secondary" prepend-icon="event" @blur="fecha_simulacion = parseDate(fecha_simulacion)" v-mask="'####-##-##'"></v-text-field>
                  </template>
                 
                  <v-date-picker  v-model="fecha_simulacion" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                  
                    <v-spacer />
                    <v-btn color="secondary" x-small @click="menu2 = false">
                      Cancelar
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              
              </v-col>
            </v-row>
            <v-icon v-if="habilitar"  small color="blue">info</v-icon><small v-if="habilitar"  style="color:#2196F3;">Los informes cargados donde el periodo sea mayor o igual a esta fecha se enviarán automaticamente al modulo de simulación.</small><p/>

          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-btn @click.native="modal_fecha = false; cargarFecha();">
          <v-icon>cancel</v-icon> Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" :loading="loading" @click.native="guardar_fecha()">
          <v-icon>done</v-icon>
          {{ update ? "Actualizar" : "Guardar" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="modal_adjuntos" max-width="20%" style=" z-index: 400 !important;">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon class="white--text" @click.native="modal_adjuntos = false">cancel</v-icon>&nbsp;
          <span class="subheading">
            <strong>Adjuntar Documento</strong>
          </span>
        </v-card>

      </v-card-title>
      <v-form ref="form_adjuntos" lazy-validation>
        <v-card-text>
          <br>
          <v-container fluid grid-list-md text-xs-center @keyup.enter="guardar_adjunto">
            <v-row row wrap>
              <v-col class="d-flex" cols="12" sm="12">
                <v-text-field label="Selecciona el archivo" @click='pickFile' v-model='model_adjuntos.nombre' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                <input type="file" style="display: none" ref="file_input" accept=".pdf" @change="onFilePicked">
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-btn @click.native="modal_adjuntos = false;">
          <v-icon>cancel</v-icon> Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" :loading="loading" @click.native="guardar_adjunto">
          <v-icon>done</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  components: {},
  data: vm => ({
    name: "datagrid",
    habilitar: false,
    fecha_simulacion: null,
    select_activo: [{
      "value": 0,
      "text": "Inactiva"
    }, {
      "value": 1,
      "text": "Activa"
    }],
    columns: [
      "regimen",
      "activo",
      "tipo_certificacion.clave",
      "tipo_certificacion.nombre",
      "folio",
      "fecha_aprobacion",
      "fecha_termino",
      "adjunto",
      "actions"
    ],
    tipo_certificaciones: [],
    show_loading: true,
    options: {
      filterable: [],
      sortable: [
        "regimen",
        "activo",
        "tipo_certificacion.clave",
        "tipo_certificacion.nombre",
        "folio",
        "fecha_aprobacion",
        "fecha_termino",
      ],
      headings: {
        regimen: "Identificador del Régimen de Operación",
        activo: "Identificador de Caso CI",
        "tipo_certificacion.clave": "Rubro Certificación",
        "tipo_certificacion.nombre": "Descripción - Rubro Certificación",
        folio: "Folio",
        fecha_aprobacion: "Fecha de Aprobación",
        fecha_termino: "Fecha de Vigencia",
        actions: "Operaciones"
      }
    },
    URL: "",
    show_loading: true,
    menu1: false,
    menu2: false,
    periodo: null,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Mis Certificaciones",
        disabled: true,
        to: ""
      }
    ],
    loading: false,
    title: "",
    modal: false,
    modal_fecha: false,
    update: false,
    model: {},
    rules: {
      required: v => !!v || "Este campo es requerido"
    },
    items: [],
    model_adjuntos: {
      archivo: "",
      ext: "",
      nombre: ""
    },
    modal_adjuntos: false,
  }),
  methods: {
    clean_model: function() {
      return {
        id: null,
        id_cliente: this.$local_storage.get("id_cliente"),
        id_tipo_certificacion: null,
        fecha_aprobacion: null,
        fecha_termino: null,
        fecha_cancelacion: null,
        folio: null,
        adjunto: null,
        id_usuario: this.$local_storage.get("id_usuario"),
        activo: 0
      }
    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    openModal: function(type) {
      if (type === 1) {
        this.model = this.clean_model();
        this.title = "Nuevo Registro";
        this.update = false;
      } else {
        this.title = "Actualizar Registro";
        this.update = true;
      }
      this.modal = true;
    },
    guardar() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var metodo = "post";
        var urlCliente = this.URL + "guardar_certificacion/";
        if (this.update == true) {
          metodo = "post";
          urlCliente = this.URL + "actualizar_certificacion/";
        }
        axios({
            method: metodo,
            url: urlCliente,
            data: this.model
          })
          .then(res => {
            this.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "Los datos se guardaron correctamente",
              footer: ""
            });
          })
          .catch(error => {
            var mensaje = "Ocurrió un error al guardar los datos";
            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
              mensaje = error.response.data.mensaje;
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
            console.log(error);
          })
          .then(() => {
            this.cargar();
            this.$root.$dialogLoader.hide();
            this.modal = false;
          });
      }
    },
    cargar: function() {
      axios
        .post(this.URL + "listar/", {
          "id_cliente": this.$local_storage.get("id_cliente")
        })
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.items = res.data;
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {

          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    getTiposCertificaciones: function() {
      this.tipo_certificaciones = [];
      axios
        .post(this.$hostname + "apendices/lista/", {
          "tabla": 35
        })
        .then(res => {
          if (typeof res.data !== "undefined") {
            for (var i = 0; i < res.data.length; i++) {
              this.tipo_certificaciones.push({
                "id": res.data[i].id,
                "text": res.data[i].clave + "-" + res.data[i].nombre
              });
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los tipos de certificacion.",
            footer: ""
          });
          console.log(err);
        });
    },
    getRegistro: function(id_registro) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios
        .post(this.URL + "get_certificacion/", {
          "id": id_registro
        })
        .then(response => {
          this.model = response.data;
          this.openModal(2); //ACTUALIZAR
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el registro" + error,
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    }, //getRegistro
    deleteRegistro: function(id_registro) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value)
          axios
          .post(this.URL + "borrar_certificacion/", {
            "id": id_registro
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El registro se eliminó correctamente.",
              //position: 'bottom-end',
              //timer: 3000,
              //showConfirmButton: false,
              footer: ""
            });
            this.cargar();
          })
          .catch(error => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al eliminar el registro",
              footer: ""
            });
          });
      });
    }, //delete
    cargarFecha: function() {
      axios
        .post(this.URL + "get_fecha_simulacion/", {
          "id": this.$local_storage.get("id_cliente")
        })
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.fecha_simulacion = res.data;
            if (this.fecha_simulacion == "") {
              this.fecha_simulacion = null;
              this.habilitar = false;
            }else{
              this.habilitar = true;
            }
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {

          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    guardar_fecha: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      if(this.habilitar == false)
        this.fecha_simulacion = null;

      axios
        .post(this.URL + "actualizar_fecha_simulacion/", {
          "id_cliente": this.$local_storage.get("id_cliente"),
          "fecha_simulacion": this.fecha_simulacion
        })
        .then(res => {
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "La Fecha se actualizó correctamente",
            footer: ""
          });
          this.cargarFecha();
          this.modal_fecha = false;
          this.$root.$dialogLoader.hide();
        })
        .catch(error => {
          var mensaje = "Ocurrió un error al actualizar la fecha";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);

          this.cargarFecha();
          this.$root.$dialogLoader.hide();
        });
    },
    descargar_adjunto: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    abrir_modal_adjuntos: function(id) {
      this.model_adjuntos = {
        "id": id,
        "archivo": null,
        "nombre": null,
        "type": null
      };

      this.modal_adjuntos = true;
    },
    guardar_adjunto: function() {
      if (!this.$refs.form_adjuntos.validate()) {
        return;
      }
      this.modal_adjuntos = false;
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var self = this;
      var keyFile = this.$local_storage.get("rfc") + "/soluciona31/adjuntos/certificaciones/" + this.model_adjuntos.nombre;

      var datos = {
        key: keyFile,
        bucket: "production.econnect.ds",
        type: this.model_adjuntos.type
      }

      axios.post(this.$hostname + 's3/upload_url/', datos).then((res) => {
          if (typeof res.data !== 'undefined') {
            var urlput = res.data.mensaje;
            axios.put(urlput, this.model_adjuntos.archivo, {
                headers: {
                  'Content-Type': this.model_adjuntos.type
                }
              })
              .then((res) => {
                self.guardar_key(keyFile);
              })
              .catch((error) => {
                var mensaje = "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.";
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                  mensaje = error.response.data.mensaje;
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: mensaje,
                  footer: '',
                });
                console.log(error);
              });

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
          this.$root.$dialogLoader.hide();
        });
    },
    pickFile() {
      this.$refs.file_input.click()
    },
    onFilePicked(e) {
      try {
        const files = e.target.files;

        if (files[0] !== undefined) {

          this.model_adjuntos.nombre = files[0].name;
          this.model_adjuntos.type = files[0].type;
          this.model_adjuntos.archivo = files[0]

        }
      } catch (error) {
        console.log(error);
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
          footer: ""
        });
        this.reset();
      }
    },
    guardar_key: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios
        .post(this.URL + "guardar_adjunto/", {
          "id": this.model_adjuntos.id,
          "key": key
        })
        .then(res => {
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "El archivo se cargo correctamente",
            footer: ""
          });
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al subir el archivo",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
          this.cargar();
        });
    },
  }, //methods
  created: function() {
    this.URL = this.$hostname + "catalogos/clientes_certificaciones/";
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.cargarFecha();
    this.cargar();
    this.getTiposCertificaciones();
  }
};
</script>
<style scoped>
.v-card--material {
  min-height: 750px !important;
}
</style>
<style scoped>
.VueTables>>>thead th {
  white-space: normal !important;
}

.VueTables>>>tbody td {
  white-space: normal !important;
}
</style>
